<template>
  <v-autocomplete :background-color="backgroundColor"
                  color="kbDarkBlueText"
                  hide-details
                  :items="timeZones"
                  item-text="label"
                  item-value="label"
                  :label="$t('general.pickTimeZone')"
                  :return-object="returnObject"
                  :rules="[rules.required]"
                  solo
                  v-model="localTimeZone" />
</template>

<script>
import rules from '@/libs/rules'
import timeZones from '@/libs/timeZones'
export default {
  computed: {
    localTimeZone: {
      get () {
        return this.timeZone
      },
      set (value) {
        this.$emit('onTimeZoneChange', value)
      }
    }
  },
  data () {
    return {
      rules,
      timeZones
    }
  },
  model: {
    prop: 'timeZone',
    event: 'onTimeZoneChange'
  },
  props: {
    backgroundColor: {
      type: String,
      default: 'kbWhite'
    },
    returnObject: {
      type: Boolean,
      default: false
    },
    timeZone: {
      type: [String, Object],
      default: ''
    }
  }
}
</script>
